import type { SignInHelperLinks } from './consoleConfig';

// FD-592 — the sign-in helper's store links, set once at boot from `config.json`.
//
// A module store rather than a context for the same reason `setActiveManagerBaseUrl`
// is one: the value is fixed for the life of the page, is read by exactly one
// component, and threading it through `EnvironmentProvider` would put a
// fleet-level fact into a value whose whole job is the ACTIVE environment.

let links: SignInHelperLinks | undefined;

export function setSignInHelperLinks(value: SignInHelperLinks | undefined): void {
  links = value;
}

export function getSignInHelperLinks(): SignInHelperLinks | undefined {
  return links;
}
